/* Shared WebGL aurora "liquid-light" background — needs <canvas id="bg"> + <div class="grain"></div>
   Optimized: half-res buffer (CSS-upscaled), 3-octave noise, 4 fbm calls, capped framerate. */
(function(){
 const cv=document.getElementById('bg');if(!cv)return;const gl=cv.getContext('webgl',{antialias:false,depth:false,powerPreference:'low-power'});
 if(!gl){cv.style.background='radial-gradient(1000px 700px at 30% 20%,#2a1440,#0a0910)';return;}
 const vs=`attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}`;
 const fs=`precision mediump float;uniform vec2 r;uniform float t;uniform vec2 m;
 vec2 h2(vec2 p){p=vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3)));return fract(sin(p)*43758.5453)*2.-1.;}
 float noise(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);
  return mix(mix(dot(h2(i),f),dot(h2(i+vec2(1,0)),f-vec2(1,0)),u.x),
             mix(dot(h2(i+vec2(0,1)),f-vec2(0,1)),dot(h2(i+vec2(1,1)),f-vec2(1,1)),u.x),u.y);}
 float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<3;i++){v+=a*noise(p);p*=2.03;a*=.5;}return v;}
 void main(){
  vec2 uv=(gl_FragCoord.xy-.5*r)/r.y;
  float tt=t*.06; vec2 q=uv*1.3;
  vec2 w=vec2(fbm(q+tt+m*.3),fbm(q-tt+vec2(3.1)));
  float n=fbm(q+w*1.6+vec2(tt*1.2,-tt));n=n*.5+.5;
  float f2=fbm(q*1.4-tt+w);
  vec3 solar=vec3(.96,.72,.12), magenta=vec3(.60,.13,.21), azure=vec3(.23,.57,.90), verd=vec3(.25,.72,.40), base=vec3(.06,.03,.045);
  vec3 col=base;
  col=mix(col,magenta,smoothstep(.14,.64,n)*.96);
  col=mix(col,azure,smoothstep(.6,.97,f2)*.24);
  col=mix(col,solar,smoothstep(.66,.94,n*.55+f2*.45)*.22);
  col=mix(col,verd,smoothstep(.74,.99,1.-f2)*.12);
  float vig=smoothstep(1.55,.0,length(uv));col*=mix(.62,1.,vig);
  col=mix(base,col,1.0);
  gl_FragColor=vec4(col,1.);
 }`;
 function sh(ty,s){const o=gl.createShader(ty);gl.shaderSource(o,s);gl.compileShader(o);return o;}
 const pr=gl.createProgram();gl.attachShader(pr,sh(gl.VERTEX_SHADER,vs));gl.attachShader(pr,sh(gl.FRAGMENT_SHADER,fs));gl.linkProgram(pr);gl.useProgram(pr);
 const buf=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buf);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
 const lp=gl.getAttribLocation(pr,'p');gl.enableVertexAttribArray(lp);gl.vertexAttribPointer(lp,2,gl.FLOAT,false,0,0);
 const ur=gl.getUniformLocation(pr,'r'),ut=gl.getUniformLocation(pr,'t'),um=gl.getUniformLocation(pr,'m');
 const RES=0.55; // internal buffer scale — CSS upscales the soft gradient, imperceptibly
 let mx=0,my=0,tmx=0,tmy=0;
 function rz(){cv.width=Math.max(2,Math.round(innerWidth*RES));cv.height=Math.max(2,Math.round(innerHeight*RES));gl.viewport(0,0,cv.width,cv.height);}
 addEventListener('resize',rz);rz();
 addEventListener('pointermove',e=>{tmx=(e.clientX/innerWidth-.5);tmy=(e.clientY/innerHeight-.5);},{passive:true});
 const start=performance.now();const FRAME=1000/32;let last=0;let hidden=false;
 document.addEventListener('visibilitychange',()=>{hidden=document.hidden;});
 function loop(now){requestAnimationFrame(loop);
  if(hidden||now-last<FRAME)return; last=now;
  mx+=(tmx-mx)*.05;my+=(tmy-my)*.05;
  gl.uniform2f(ur,cv.width,cv.height);gl.uniform1f(ut,(now-start)/1000);gl.uniform2f(um,mx,my);
  gl.drawArrays(gl.TRIANGLES,0,3);}
 requestAnimationFrame(loop);
})();
